import { render, staticRenderFns } from "./operationDialog.vue?vue&type=template&id=65fd5928&scoped=true"
import script from "./operationDialog.vue?vue&type=script&lang=js"
export * from "./operationDialog.vue?vue&type=script&lang=js"
import style0 from "./operationDialog.vue?vue&type=style&index=0&id=65fd5928&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd5928",
  null
  
)

export default component.exports